// extracted by mini-css-extract-plugin
export default {"gridItem":"styles_gridItem__OxFR9","tooltip":"styles_tooltip__FeirX"};